import {Injectable} from "@angular/core";
import {AccountTrader} from "../../../model/customer/account-trader";
import {Owner} from "../../../model/customer/owner";
import {ClearingHouse} from "../../../model/exchange/clearing-house";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {ExecTrader} from "../../../model/customer/exec-trader";
import {MoneyOwner} from "../../../model/customer/money-owner";
import {AccountDefinition} from "../../../model/customer/account-definition";
import {StringUtils} from "../../../utils/stringUtils";
import {Trade} from "../../../model/clearing/trade";
import {AppConfigService} from "../../app-config.service";
import {ClearingFlexService} from "./clearing-flex.service";
import {FieldRecord} from "../../../model/api/field-record";
import {Trader} from "../../../model/customer/trader";
import {BrokerageTable} from "../../../model/customer/brokerage-table";
import {CommonFieldService} from "../../common/common-field.service";
import {FieldsService} from "../../common/fields-service";
import {FieldRequest} from "../../../model/api/field-request";
import {Customer} from "../../../model/customer/customer";
import {ProgressTracker} from "../../../model/api/progress-tracker";

@Injectable({
  providedIn: 'root'
})
export class ClearingFlexOrderDataLoadingService {

  orderFlexTemplates: FieldRecord<any>[] = [];

  constructor(
    private fieldsService: FieldsService,
    private clearingFlexService: ClearingFlexService) {
  }

  loadData(tracker: ProgressTracker) {
    // init data
    this.fieldsService.loadField(this.orderFlexTemplates, () => this.clearingFlexService.getOrderTemplates(), tracker, (records) => {
      records.forEach(field => {
        field.text = StringUtils.humanize(field.text);
      });
    });

  }
}
